import { DialogComponent } from '@theme/dialog';

class CrbnMenuDrawer extends DialogComponent {
  open() {
    this.querySelector('.crbn-nav__trigger')?.setAttribute('aria-expanded', 'true');
    this.showDialog();
  }

  close() {
    this.querySelector('.crbn-nav__trigger')?.setAttribute('aria-expanded', 'false');
    this.closeDialog();
  }

  connectedCallback() {
    super.connectedCallback?.();
    this.addEventListener('click', (event) => {
      if (event.target.closest('.crbn-menu-drawer__navigation a, .crbn-menu-drawer__footer a')) this.close();
    });
  }
}

if (!customElements.get('crbn-menu-drawer')) {
  customElements.define('crbn-menu-drawer', CrbnMenuDrawer);
}
